import { LEARNER } from 'constants/api';
import axios from 'utils/axios';

export const getLearners = async (data) => {
    const result = await axios.get(LEARNER.v2.fetchLearners, {
        params: data
    });
    return result.data;
};

export const learnersCount = async (data) => {
    const result = await axios.get(LEARNER.v2.learnersCount, {
        params: data
    });
    return result.data;
};

export const resendInvitation = async (data) => {
    const result = await axios.post(LEARNER.v2.resendInvitation, data);
    return result.data;
};

export const editLearner = async (data, id) => {
    const result = await axios.put(`${LEARNER.v2.editLearner}/${id}`, data);
    return result.data;
};

export const editLearnerResults = async (data) => {
    const result = await axios.put(LEARNER.v2.editResults, data);
    return result.data;
};

export const getArchiveFolders = async (data) => {
    const result = await axios.get(LEARNER.v2.archiveFolders, {
        params: data
    });
    return result.data;
};

export const getArchiveLearners = async (data) => {
    const result = await axios.get(LEARNER.v2.archiveLearners, {
        params: data
    });
    return result.data;
};

export const getDeletedList = async (data) => {
    const result = await axios.get(LEARNER.v2.deletedLearners, {
        params: data
    });
    return result.data;
};

export const archiveLearners = async (data) => {
    const result = await axios.post(LEARNER.v2.postArchiveLearners, data);
    return result.data;
};

export const unarchiveLearners = async (data) => {
    const result = await axios.post(LEARNER.v2.postUnarchiveLearners, data);
    return result.data;
};

export const deleteLearners = async (learnerIds) => {
    const result = await axios.delete(LEARNER.v2.deleteLearners, {
        data: {
            learnerIds
        }
    });
    return result.data;
};

export const restoreLearners = async (data) => {
    const result = await axios.post(LEARNER.v2.restoreLearners, data);
    return result.data;
};

export const sendVfhResultsEmail = async (data) => {
    const result = await axios.post(LEARNER.v2.vfhResultsEmail, data);
    return result.data;
};

export const inviteLearner = async (data) => {
    const result = await axios.post(LEARNER.v1.inviteLearner, data);
    return result.data;
};
